import {
  ClipboardCheckIcon,
  ClipboardListIcon,
  KeyIcon,
  UserCircleIcon,
} from '@heroicons/react/outline';
import ApplicantInformation from './ApplicantInformation';
import Experience from './Experience';
import LeadershipInformation from './LeadershipInformation';
import ProjectDetails from './ProjectDetails';
import Review from './Review';
import { useState } from 'react';

import EnterpriseLBALogo from '../../../images/logos/lets-build-accelerator-logo.jpg';

const steps = [
  {
    name: 'Project Details',
    path: 'project-details',
    Icon: ClipboardListIcon,
    current: true,
  },
  {
    name: 'Applicant Information',
    path: 'applicant-information',
    Icon: UserCircleIcon,
    current: true,
  },
  {
    name: 'Leadership Information',
    path: 'leadership-information',
    Icon: UserCircleIcon,
    current: true,
  },
  {
    name: 'Experience',
    path: 'experience',
    Icon: KeyIcon,
    current: false,
  },
  {
    name: 'Review',
    path: 'review',
    Icon: ClipboardCheckIcon,
    current: false,
  },
];

interface StepFormMap {
  [id: string]: React.ReactNode;
}

export default function EnterpriseLBAForm() {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const isFirst = currentStep === 0;
  const isLast = currentStep === steps.length - 1;

  const increaseStep = () => {
    if (!isLast) {
      setCurrentStep((prev) => prev + 1);
    }
  };
  const decreaseStep = () => {
    if (!isFirst) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const goToStepHandler = (step: number) => {
    setCurrentStep(step);
  };

  const stepFormMap: StepFormMap = {
    0: <ProjectDetails nextHandler={increaseStep} />,
    1: (
      <ApplicantInformation
        nextHandler={increaseStep}
        previousHandler={decreaseStep}
      />
    ),
    2: (
      <LeadershipInformation
        nextHandler={increaseStep}
        previousHandler={decreaseStep}
      />
    ),
    3: <Experience nextHandler={increaseStep} previousHandler={decreaseStep} />,
    4: (
      <Review
        previousHandler={decreaseStep}
        goToStepHandler={goToStepHandler}
      />
    ),
  };

  return (
    <div className='container mx-auto'>
      <h2>Let's Build Accelerator</h2>
      <div className='flex mb-10'>
        <aside className='w-1/4 py-6 px-2 sm:px-6 bg-white rounded-l-md'>
          <div className='w-full flex justify-center'>
            <img
              src={EnterpriseLBALogo}
              alt='logo'
              className='h-14 xl:h-20 object-scale-down '
            />
          </div>
          <nav className='space-y-1 py-5'>
            {steps.map(({ name, Icon }, index) => (
              <button
                key={index}
                className={`${
                  currentStep === index
                    ? 'bg-neutralColor-lightest text-primaryColor-normal'
                    : 'text-neutralColor-normal'
                } group rounded-md px-3 py-2 flex items-center text-sm font-medium w-full`}
              >
                <Icon className='flex-shrink-0 -ml-1 mr-3 h-6 w-6' />
                {name}
              </button>
            ))}
          </nav>
        </aside>
        <div className='w-full bg-gray-50'>{stepFormMap[`${currentStep}`]}</div>
      </div>
    </div>
  );
}
